export const LOGISTICS_QUOTE_URL = 'https://safi.atlassian.net/servicedesk/customer/portal/2/group/2/create/6';
